import { watch } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-tw';

/**
 * vue-i18n 语言标识与 dayjs 不一致，统一在此映射
 * @param {string} [i18nLocale]
 * @returns {'zh-cn'|'en'|'zh-tw'}
 */
export function mapI18nLocaleToDayjs(i18nLocale) {
  if (!i18nLocale) return 'zh-cn';
  if (i18nLocale === 'en-US') return 'en';
  if (i18nLocale === 'zh-TW') return 'zh-tw';
  return 'zh-cn';
}

/**
 * 根据当前 vue-i18n 语言设置 dayjs 全局 locale（含切换语言后的同步）
 * 在 main.js 中 app.use(i18n) 之后调用一次即可
 * @param {import('vue-i18n').I18n} i18nInstance
 */
export function initDayjsLocaleSync(i18nInstance) {
  const apply = () => {
    const loc = i18nInstance.global.locale;
    const raw = typeof loc === 'object' && loc !== null && 'value' in loc ? loc.value : loc;
    dayjs.locale(mapI18nLocaleToDayjs(raw));
  };
  apply();
  watch(i18nInstance.global.locale, apply);
}
